/* Constants used throughout the application */

//export const ROOT_URL = 'http://localhost:3090';
export const ROOT_URL = 'https://www.rhs.systems';
// export const ROOT_URL = 'https://www.himn-api.systems'; // Staging
// Max grade for non-regular employees; if this changes, update this number
export const MAX_NON_REG_GRADE = 6.1

// If it is necessary to update timesheets past a pay period is closed; update DAYS_FOR_ADMINS; default is 5
// @imported actions/index.js/fetchTimesheetDatesToEdit() 
export const DAYS_FOR_ADMINS = 5

/* Master Navigation URL's */
export const URLS = [
  { name: 'Dashboard', url: '/dashboard', _class: 'purple', icon: 'dashboard' },
  { name: 'Timesheet', url: '/timesheet', _class: 'black', icon: 'query_builder' },
  { name: 'Team Builder', url: '/teambuilder', _class: 'cyan', icon: 'extension' },
  { name: 'Profile', url: '/profile', _class: 'grey', icon: 'account_circle' },
  { name: 'Alert', url: '/alert', _class: 'red', icon: 'message' },
  { name: 'Harvest', url: '/harvest', _class: 'indigo', icon: 'grid_on' },
  { name: 'Cultivation', url: '/cultivation', _class: 'green', icon: 'brightness_7' },
  { name: 'Irrigation', url: '/irrigation', _class: 'blue', icon: 'opacity' },
  { name: 'Interval', url: '/interval', _class: 'brown', icon: 'event_note' }
];

/* Timesheet specific URL's */
export const TIMESHEET_URLS = [
  { name: 'View Timesheet', url: '/timesheet', level: 0 },
  { name: 'Create Timesheet', url: '/timesheet/create', level: 1 },
  { name: 'Edit Timesheet', url: '/timesheet/edit', level: 2 },
  { name: 'Delete Timesheet', url: '/timesheet/delete', level: 3 }
];

/* Profile specific URL's */
export const PROFILE_URLS = [
  { name: 'View Profile', url: '/profile', level: 0 },
  { name: 'Create Profile', url: '/profile/create', level: 4 },
  { name: 'Edit Profile', url: '/profile/edit', level: 4 }
];

/* Gang specific URL's */
export const TEAM_URLS = [
  { name: 'View Teams', url: '/teambuilder', level: 0 },
  { name: 'Create Teams', url: '/teambuilder/create', level: 2 },
  { name: 'Edit Teams', url: '/teambuilder/edit', level: 2 },
  { name: 'Delete Teams', url: '/teambuilder/delete', level: 2 }
];

/* Mechanical harvest URL's */
export const MECH_HARVEST_URLS = [
  { name: 'View Harvest', url: '/harvest', level: 0 },
  { name: 'Create Mechanical Harvest', url: '/harvest/create', level: 3 },
  { name: 'Manage Mechanical Harvest', url: '/harvest/manage', level: 3 }
];

/* Mechanical harvest URL's */
export const IRRIGATION_URLS = [
  { name: 'View Irrigation', url: '/irrigation', level: 0 },
  { name: 'Create Irrigation', url: '/irrigation/create', level: 3 },
  { name: 'Manage Irrigation', url: '/irrigation/manage', level: 3 }
];
/* Locations URL's */
export const LOCATIONS = [
  { val: '71', label: '71 - Kau' },
  { val: '72', label: '72 - Keaau' },
  { val: '75', label: '75 - Naalehu' }
];

export const PROFILE_LOCATIONS = [
  { val: '60', label: '60 - California' },
  { val: '70', label: '70 - Admin' },
  { val: '71', label: '71 - Kau' },
  { val: '72', label: '72 - Keaau' },
  { val: '75', label: '75 - Naalehu' },
];

/* Type of employee: Salary or Union */
export const TYPES = [
  { val: 'BU', label: 'BU' },
  { val: 'SAL', label: 'SAL' }
];

export const BU_TYPES = [
  { val: 'Covered Seasonal', label: 'Covered Seasonal' },
  { val: 'Non-Covered Seasonal', label: 'Non-Covered Seasonal' },
  { val: 'Intermittent', label: 'Intermittent' },
  { val: 'Regular', label: 'Regular' }
];

/* The levels of authentication for each employee */
export const LEVELS = [
  { val: 0, label: '0 - Union: Basic Employee' },
  { val: 1, label: '1 - Union: Timesheet Employee' },
  { val: 2, label: '2 - Supervisor' },
  { val: 3, label: '3 - Manager' },
  { val: 4, label: '4 - HR / Administrator' }
];
/* Harvest status of a field */
export const STATUS = [
  { val: 1, label: 'Complete' },
  { val: 0, label: 'Incomplete' }
];

/* For shift differential payments: Only happens in Kau */
export const DIFFERENTIAL_SLOT = [
  { val: '6-12', label: '6-12' },
  { val: '12-5', label: '12-5' }
];

/* Employee Grades */
export const GRADES = [
  { val: 1, label: 1 },
  { val: 2, label: 2 },
  { val: 2.1, label: 2.1 },
  { val: 3, label: 3 },
  { val: 3.1, label: 3.1 },
  { val: 4, label: 4 },
  { val: 4.1, label: 4.1 },
  { val: 5, label: 5 },
  { val: 5.1, label: 5.1 },
  { val: 6, label: 6 },
  { val: 6.1, label: 6.1 },
  { val: 7, label: 7 },
  { val: 7.1, label: 7.1 },
  { val: 8, label: 8 },
  { val: 8.1, label: 8.1 },
  { val: 9, label: 9 },
  { val: 9.1, label: 9.1 },
  { val: 10, label: 10 },
  { val: 10.1, label: 10.1 },
  { val: 11, label: 11 },
  { val: 11.1, label: 11.1 }
];
/* Used in finance payrate edit */
export const PAYRATE_GRADES = [
  { val: 1, label: 1 },
  { val: 2, label: 2 },
  { val: 3, label: 3 },
  { val: 4, label: 4 },
  { val: 5, label: 5 },
  { val: 6, label: 6 },
  { val: 7, label: 7 },
  { val: 8, label: 8 },
  { val: 9, label: 9 },
  { val: 10, label: 10 },
  { val: 11, label: 11 }
];

/* Used in finance payrate edit */
export const PAYRATE_YEARS = [
  { val: 1, label: 1 },
  { val: 2, label: 2 },
  { val: 3, label: 3 },
  { val: 4, label: 4 }
];

export const SUBGRADES = [
  { val: 'A', label: 'A' },
  { val: 'B', label: 'B' },
  { val: 'C', label: 'C' },
  { val: 'D', label: 'D' },
  { val: 'E', label: 'E' },
  { val: 'F', label: 'F' },
  { val: 'G', label: 'G' }
];

/* Employee Shifts */
export const SHIFTS = [
  { val: 1, label: 1 },
  { val: 2, label: 2 },
  { val: 3, label: 3 }
];

export const SMS_MESSAGES = [
  { value: 'Test', msg: 'ALERT: This is a test alert' },
  { value: 'Rain', msg: 'ALERT: Work has been cancelled today due to heavy rainfall in the orchards.' },
  { value: 'Vog', msg: 'ALERT: Work has been cancelled today due to excessive vog/ash in the orchards.' },
  { value: 'Lightning', msg: 'ALERT: Work has been cancelled today due to lightning close to the orchards.' },
  { value: 'Disaster', msg: 'ALERT: Work has been cancelled today due to a natural disaster near the orchards.' },
  { value: 'Threat', msg: 'ALERT: There is an ongoing threat in the orchards.' }
]
/*
export const FAULT_TYPES = [
  { header: 'Irrigation', icon: 'opacity', desc: 'Irrigation Required', color: '#2196f3', borderColor: '#90caf9', headerColor: '#e3f2fd', onclick: () => console.log('Clicked!') },
  { header: 'Fallen Branches', icon: 'nature', desc: 'Clear Fallen Branches', color: '#4caf50', borderColor: '#a5d6a7', headerColor: '#e8f5e9', onclick: () => console.log('Clicked!') },
  { header: 'Harvest Machines', icon: 'healing', desc: 'Repair Harvest Machines', color: '', borderColor: '', headerColor: '', onclick: () => console.log('Clicked!') },
  { header: 'Husking Station', icon: 'toys', desc: 'Husking Station Repairs', color: '#009688', borderColor: '#80cbc4', headerColor: '#e0f2f1', onclick: () => console.log('Clicked!') },
  { header: 'Broken Water Lines', icon: 'warning', desc: 'Repair Broken Water Lines', color: '#3f51b5 ', borderColor: '#9fa8da', headerColor: '#e8eaf6', onclick: () => console.log('Clicked!') },
  { header: 'Rock Clearing', icon: 'landscape', desc: 'Clear Problematic Rocks', color: '#f44336', borderColor: '#ef9a9a', headerColor: '#ffebee', onclick: () => console.log('Clicked!') },
  { header: 'Machine Repair', icon: 'build', desc: 'Repair a Machine', color: '', borderColor: '', headerColor: '', onclick: () => console.log('Clicked!') },
  { header: 'Tractor Clearing', icon: 'grid_on', desc: 'Clearing with Tractor', color: '', borderColor: '', headerColor: '', onclick: () => console.log('Clicked!') },
  { header: 'Tree Replants', icon: 'nature_people', desc: 'Replant Trees', color: '#8bc34a', borderColor: '#c5e1a5', headerColor: '#f1f8e9', onclick: () => console.log('Clicked!') },
  { header: 'Other', icon: 'priority_high', desc: 'Other Fault', color: '#9e9e9e', borderColor: '#eeeeee', headerColor: '#fafafa', onclick: () => console.log('Clicked!') }
]
*/
/*
export const SP_PAY_CODE = [
  { val: '01', label: '01 - Vacation Non-Option' },
  { val: '02', label: '02 - Sick' },
  { val: '03', label: '03 - Sick, Supplemental' },
  { val: '05', label: '05 - Holiday' },
  { val: '06', label: '06 - Ind. Accident' },
  { val: '07', label: '07 - State TDI' },
  { val: '08', label: '08 - Jury Duty' },
  { val: '09', label: '09 - Boards & Comm.' },
  { val: '10', label: '10 - Funeral Leave' },
  { val: '11', label: '11 - Vacation In Lieu of Sick' },
  { val: '12', label: '12 - Vacation Option' },
  { val: '13', label: '13 - Vacation, Scheduled Carryover' },
  { val: '30', label: '30 - Stop Work Meeting' },
  { val: '31', label: '31 - Suspension' },
  { val: '32', label: '32 - Excused Absence' },
  { val: '33', label: '33 - Unexcused Absence' },
  { val: '34', label: '34 - Military Leave' },
  { val: '36', label: '36 - Ind. Accident Workers Comp.' },
  { val: '38', label: '38 - No Work Available' },
  { val: '39', label: '39 - Sick Without Pay' },
  { val: '40', label: '40 - Absence Without Pay' },
  { val: '41', label: '41 - Day of Rest' },
  { val: '42', label: '42 - 1FE (Employee Pay)' },
  { val: '43', label: '43 - 1FF (Family Care Pay)' },
  { val: '44', label: '44 - 1FA (FMLA Expansion)' },
  { val: '45', label: '45 - COV (COVID Pay-ETS)' },
  { val: '50', label: '50 - Meal Penalty' },
  { val: '51', label: '51 - Report Call Out S.T.' },
  { val: '52', label: '52 - Report Call Out O.T.' },
  { val: '53', label: '53 - Report Call Out D.T.' },
  { val: '54', label: '54 - Vacation - Pay in Lieu' },
  { val: '55', label: '55 - Vacation - Pro Rata' },
  { val: '56', label: '56 - Holiday Pay on Sick Day' },
  { val: '61', label: '61 - Severance - Lay off' },
  { val: '62', label: '62 - Severance - Interim Retirement' },
  { val: '65', label: '65 - Severance - Interim Disability' },
  { val: '69', label: '69 - Other Pay' }
];
*/
export const EMPLOYEE_STATUS = [
  { val: 'Active', label: 'Active' },
  { val: 'Inactive', label: 'Inactive' },
  { val: 'LOA', label: 'LOA' },
  { val: 'Terminated', label: 'Terminated' }
];

export const EMPLOYEE_ATTENDANCE = [
  { name: 'dashboard-attendance-location', id: 'attendance-both-loc', label: 'Both' },
  { name: 'dashboard-attendance-location', id: 'attendance-kau-loc', label: `Ka'u` },
  { name: 'dashboard-attendance-location', id: 'attendance-keaau-loc', label: `Kea'au` }
];

export const LABORS_HOURS_BY_FIELD = [
  { name: 'dashboard-field-location', id: 'field-both-loc', label: 'Both' },
  { name: 'dashboard-field-location', id: 'field-kau-loc', label: `Ka'u` },
  { name: 'dashboard-field-location', id: 'field-keaau-loc', label: `Kea'au` }
];

export const DENSITY_BY_FIELD = [
  { name: 'dashboard-density-location', id: 'density-both-loc', label: 'Both' },
  { name: 'dashboard-density-location', id: 'density-kau-loc', label: `Ka'u` },
  { name: 'dashboard-density-location', id: 'density-keaau-loc', label: `Kea'au` }
];
/* For dashboard departments */
export const DEPARTMENTS = {
  'Harvesting': 'red',
  'Hand Harvest': 'blue-grey',
  'Garage Direct': 'indigo',
  'Field General': 'purple',
  'Drying': 'cyan',
  'Maintenance Shop': 'teal',
  'Mechanical Harvest': 'grey',
  'Other Field Operations': 'red lighten-3',
  'Agri Development': 'green darken-2',
  'Palima Engine': 'cyan accent-2',
  'Palima Well': 'teal accent-4',
  'Pest Control': 'lime darken-4',
  'QA Lab/Husk disposal': 'orange lighten-1',
  'Weed Control': 'brown lighten-2',
  'Irrigation': 'blue',
  'Husking': 'deep-purple',
  'Total': 'black'
};

/* Mech. harvest container types */
export const CONTAINER_TYPES = [
  { val: 'Bin', label: 'Bin' },
  { val: 'Trailer', label: 'Trailer' }
];

/* Coodinates created from GIMP ImageMap; each set of coordinates maps to a field in Kau */
export const KAU_FIELD_MAP = [
  { shape: 'poly', coords: '871,684,995,691,1012,726,1055,757,1047,806,1001,812,985,832,932,816,886,823,853,814,844,779,867,730,870,717,871,684', alt: 'E410', id: 'E410' },
  { shape: 'poly', coords: '1009,690,1019,711,1054,744,1076,757,1074,810,1090,832,1111,829,1123,806,1119,788,1169,711,1171,686,1165,675,1165,661,1077,690,1010,691', alt: 'E415', id: 'E415' },
  { shape: 'poly', coords: '1137,794,1130,831,1121,830,1121,855,1142,851,1172,850,1207,781,1258,770,1287,752,1331,752,1346,726,1303,727,1286,751,1256,771,1204,782,1136,795', alt: 'W510', id: 'W510' },
  { shape: 'poly', coords: '1196,653,1308,621,1305,701,1362,703,1348,724,1301,724,1281,751,1253,768,1137,791,1169,732,1191,708,1194,653', alt: 'W515', id: 'W515' },
  { shape: 'poly', coords: '1311,623,1594,539,1633,532,1620,601,1535,641,1477,682,1427,688,1390,715,1368,711,1372,699,1310,698,1313,621', alt: 'T610', id: 'T610' },
  { shape: 'poly', coords: '1572,537,1635,524,1647,430,1640,408,1631,402,1623,407,1620,415,1616,439,1604,446,1600,430,1590,415,1581,412,1575,425,1568,487,1563,499,1576,521,1574,538', alt: 'H650', id: 'H650' },
  { shape: 'poly', coords: '1733,377,1736,339,1757,332,1781,300,1799,327,1732,375', alt: 'A730', id: 'A730' },
  { shape: 'poly', coords: '1795,336,1790,368,1723,416,1722,385,1797,335', alt: 'B725', id: 'B725' },
  { shape: 'poly', coords: '1725,420,1748,435,1839,363,1853,271,1842,250,1822,255,1822,289,1812,334,1818,350,1727,419', alt: 'C720', id: 'C720' },
  { shape: 'poly', coords: '1842,368,1811,389,1809,425,1802,449,1783,468,1822,469,1829,432,1843,370', alt: 'D716', id: 'D716' },
  { shape: 'poly', coords: '1808,394,1752,440,1751,454,1775,461,1787,460,1802,447,1808,418,1807,395', alt: 'D715', id: 'D715' },
  { shape: 'poly', coords: '1543,548,1570,540,1574,522,1561,505,1564,488,1570,431,1570,414,1563,417,1557,428,1557,437,1552,452,1544,475,1538,488,1534,492,1526,491,1503,507,1504,522,1525,518,1534,521,1539,520', alt: 'Y655', id: 'Y655' },
  { shape: 'poly', coords: '1303,494,1322,520,1311,614,1541,547,1530,522,1515,521,1500,527,1496,504,1523,486,1536,487,1544,462,1529,448,1495,473,1461,464,1365,439,1332,468,1315,469,1304,493', alt: 'H615', id: 'H615' },
  { shape: 'poly', coords: '1360,378,1423,417,1437,414,1471,363,1433,329,1362,378', alt: 'K552', id: 'K552' },
  { shape: 'poly', coords: '1476,268,1487,280,1492,303,1471,358,1431,324,1475,269', alt: 'K553', id: 'K553' },
  { shape: 'poly', coords: '1472,368,1522,377,1544,386,1518,416,1495,435,1521,445,1495,469,1372,438,1410,417,1436,420,1471,371', alt: 'H620', id: 'H620' },
  { shape: 'poly', coords: '1649,421,1673,292,1660,286,1679,248,1615,293,1593,335,1568,374,1549,385,1503,434,1532,443,1552,420,1564,397,1591,412,1602,422,1606,438,1615,435,1618,404,1631,397,1641,399,1648,418', alt: 'Y660', id: 'Y660' },
  { shape: 'poly', coords: '1088,406,1087,452,1114,448,1153,457,1186,470,1202,487,1231,485,1216,412,1189,415,1158,414,1146,403,1103,402,1090,405', alt: 'F450', id: 'F450' },
  { shape: 'poly', coords: '1089,359,1087,406,1101,399,1149,400,1160,411,1214,411,1240,377,1253,350,1224,343,1213,337,1191,344,1143,344,1089,358', alt: 'G455', id: 'G455' },
  { shape: 'poly', coords: '1021,358,1073,362,1080,364,1083,449,1067,477,1057,523,1029,518,1018,545,984,564,981,562,1005,531,1023,453,1029,434,1005,393,1021,357,1020,356,1019,357', alt: 'G430', id: 'G430' },
  { shape: 'poly', coords: '829,428,849,439,885,439,962,449,1019,457,1026,434,1003,398,958,396,920,396,906,391,897,381,885,383,872,398,853,394,831,424', alt: 'G320', id: 'G320' },
  { shape: 'poly', coords: '825,427,794,417,773,401,758,425,768,453,795,463,798,496,771,507,777,519,804,527,843,525,872,524,890,540,950,568,993,527,1008,460,882,442,850,443,823,427', alt: 'G315', id: 'G315' },
  { shape: 'poly', coords: '801,529,788,549,803,603,814,625,831,650,867,668,883,641,915,608,944,569,878,538,866,527,800,531', alt: 'F310', id: 'F310' },
  { shape: 'poly', coords: '958,571,1011,583,1041,586,1061,619,1008,684,883,673,887,646,920,642,942,582,958,573', alt: 'F420', id: 'F420' },
  { shape: 'poly', coords: '668,445,655,514,636,514,635,499,614,500,609,525,592,528,580,542,510,594,537,613,542,617,645,606,650,553,743,521,682,439,669,444', alt: 'M250', id: 'M250' },
  { shape: 'poly', coords: '478,416,405,574,394,636,452,634,509,624,518,606,503,595,579,539,587,525,569,519,573,509,607,519,610,499,621,471,618,435,572,423,559,430,543,444,539,425,522,410,480,416', alt: 'M210', id: 'M210' },
  { shape: 'poly', coords: '621,436,623,477,611,499,609,523,576,511,573,519,596,524,607,523,613,496,624,475,640,476,643,438,622,436', alt: 'N275', id: 'N275' },
  { shape: 'poly', coords: '481,414,523,404,542,389,576,380,618,389,644,394,669,397,670,389,657,375,653,360,642,325,631,325,615,306,599,294,592,295,604,335,614,351,567,317,543,317,516,297,511,321,510,333,482,413', alt: 'M215', id: 'M215' },
  { shape: 'poly', coords: '600,288,584,242,577,219,540,226,545,250,505,257,485,243,466,246,476,265,495,277,517,291,541,311,567,312,604,339,585,293,599,291', alt: 'G220', id: 'G220' },
  { shape: 'poly', coords: '431,225,452,230,458,244,471,267,513,292,505,336,473,416,381,417,389,361,405,334,434,282,431,226,430,225,431,226', alt: 'L160', id: 'L160' },
  { shape: 'poly', coords: '241,415,376,419,472,419,436,492,376,493,262,497,239,415', alt: 'L150', id: 'L150' },
  { shape: 'poly', coords: '230,162,305,210,383,245,430,284,386,358,377,416,238,412,173,220,200,217,229,165', alt: 'L155', id: 'L155' },
  { shape: 'poly', coords: '40,198,38,170,74,158,108,164,110,200,40,199', alt: 'G110', id: 'G110' },
  { shape: 'poly', coords: '96,207,128,228,148,306,199,306,213,357,143,352,115,355,95,377,83,335,102,300,97,207', alt: 'F105', id: 'F105' }
];
/* Coodinates created from GIMP ImageMap; each set of coordinates maps to a field in Keaau */
export const KEAAU_FIELD_MAP = [
  { shape: 'poly', coords: '235,75,320,89,371,90,369,128,239,123,233,74', alt: 'H016', id: 'H016' },
  { shape: 'poly', coords: '376,91,438,82,511,57,510,127,374,125,376,90', alt: 'H015', id: 'H015' },
  { shape: 'poly', coords: '517,56,554,40,595,35,649,126,514,126,517,58', alt: 'H005', id: 'H005' },
  { shape: 'poly', coords: '239,127,246,215,367,214,368,130,239,126', alt: 'H017', id: 'H017' },
  { shape: 'poly', coords: '373,128,511,130,509,211,372,213,374,129', alt: 'H014', id: 'H014' },
  { shape: 'poly', coords: '516,130,515,213,648,212,647,129,516,131', alt: 'H006', id: 'H006' },
  { shape: 'poly', coords: '653,132,654,212,700,213,653,135', alt: 'H004', id: 'H004' },
  { shape: 'poly', coords: '247,219,254,300,366,302,367,217,247,220', alt: 'H018', id: 'H018' },
  { shape: 'poly', coords: '373,218,372,302,508,302,509,219,374,219', alt: 'H013', id: 'H013' },
  { shape: 'poly', coords: '514,219,515,302,647,304,648,217,515,217', alt: 'H007', id: 'H007' },
  { shape: 'poly', coords: '652,217,700,217,752,304,654,304', alt: 'H003', id: 'H003' },
  { shape: 'poly', coords: '255,304,263,390,369,390,369,306', alt: 'H019', id: 'H019' },
  { shape: 'poly', coords: '373,308,509,309,510,394,374,392', alt: 'H012', id: 'H012' },
  { shape: 'poly', coords: '374,395,375,476,508,477,508,396', alt: 'H011', id: 'H011' },
  { shape: 'poly', coords: '514,307,647,309,648,392,515,391', alt: 'H008', id: 'H008' },
  { shape: 'poly', coords: '653,308,753,308,811,393,655,394', alt: 'H0002', id: 'H002' },
  { shape: 'poly', coords: '265,395,368,395,370,478,255,478', alt: 'H020', id: 'H020' },
  { shape: 'poly', coords: '514,397,517,477,646,479,647,397', alt: 'H009', id: 'H009' },
  { shape: 'poly', coords: '656,399,815,398,815,478,654,479', alt: 'H001', id: 'H001' },
  { shape: 'poly', coords: '35,476,258,393,172,477', alt: 'H025', id: 'H025' },
  { shape: 'poly', coords: '30,482,56,566,237,567,238,483', alt: 'H024', id: 'H024' },
  { shape: 'poly', coords: '241,484,242,569,370,570,370,481', alt: 'H021', id: 'H021' },
  { shape: 'poly', coords: '373,510,375,576,503,511', alt: 'H078', id: 'H078' },
  { shape: 'poly', coords: '375,481,565,481,512,507,374,507', alt: 'H010', id: 'H010' },
  { shape: 'poly', coords: '376,581,376,604,461,604,462,535', alt: 'H054', id: 'H054' },
  { shape: 'poly', coords: '466,535,568,486,560,552,542,564,539,603,466,606', alt: 'H055', id: 'H055' },
  { shape: 'poly', coords: '571,485,572,510,744,507,745,482,571,482', alt: 'W113', id: 'W113' },
  { shape: 'poly', coords: '570,511,754,513,756,553,749,554,749,592,573,593,565,558', alt: 'W111', id: 'W111' },
  { shape: 'poly', coords: '748,484,816,485,813,566,754,565,754,558,759,552,759,510,750,508', alt: 'H056', id: 'H056' },
  { shape: 'poly', coords: '753,569,817,571,813,656,751,655', alt: 'H057', id: 'H057' },
  { shape: 'poly', coords: '750,658,813,660,811,777,751,779', alt: 'H058', id: 'H058' },
  { shape: 'poly', coords: '574,598,596,673,746,674,746,595', alt: 'W110', id: 'W110' },
  { shape: 'poly', coords: '591,677,516,725,518,757,746,755,745,677', alt: 'Q109', id: 'Q109' },
  { shape: 'poly', coords: '517,761,506,832,747,836,745,761', alt: 'Q108', id: 'Q108' },
  { shape: 'poly', coords: '373,609,372,691,459,692,461,609', alt: 'H053', id: 'H053' },
  { shape: 'poly', coords: '375,694,372,776,459,778,457,696', alt: 'H052', id: 'H052' },
  { shape: 'poly', coords: '466,610,542,609,525,676,464,675,465,674', alt: 'H051', id: 'H051' },
  { shape: 'poly', coords: '463,678,464,746,505,747,522,680,521,680,522,678', alt: 'H114', id: 'H114' },
  { shape: 'poly', coords: '156,572,170,605,193,635,239,637,238,571', alt: 'H023', id: 'H023' },
  { shape: 'poly', coords: '241,572,370,574,367,640,242,637,243,637,241,636', alt: 'H022', id: 'H022' },
  { shape: 'poly', coords: '241,640,370,644,369,750,179,750,181,732,219,698,220,673,241,671', alt: 'T104', id: 'T104' },
  { shape: 'poly', coords: '179,755,368,756,368,775,343,776,345,835,74,834,77,816', alt: 'Z103', id: 'Z103' },
  { shape: 'poly', coords: '75,838,367,841,367,962,119,964,57,887,76,840', alt: 'S102', id: 'S102' },
  { shape: 'poly', coords: '320,967,370,967,368,1013,320,1013', alt: 'P112', id: 'P112' },
  { shape: 'poly', coords: '317,968,117,969,57,995,12,1057,315,1059', alt: 'P101', id: 'P101' },
  { shape: 'poly', coords: '375,839,556,841,558,966,375,964', alt: 'D107', id: 'D107' },
  { shape: 'poly', coords: '562,842,747,843,746,967,565,966', alt: 'C107', id: 'C107' },
  { shape: 'poly', coords: '375,969,373,1017,438,1022,457,1030,456,1044,746,1049,745,972', alt: 'B106', id: 'B106' },
  { shape: 'poly', coords: '459,1047,672,1053,712,1081,710,1094,694,1096,683,1110,661,1108,639,1131,460,1129', alt: 'A105', id: 'A105' }
];





/* END */



// WEBPACK FOOTER //
// ./src/constants.js